//@flow
import * as React from "react";
import Link from "gatsby-link";
import styled from "react-emotion";
import { theme, mqMin } from "../../styles/theme";
import { Fade } from "react-reveal";

const Screen = styled.div`
  padding: ${theme.space2};
  width: 100%;
  flex: 0 0 auto;
  ${mqMin(theme.tablet)} {
    width: 50%;
  }
`;

const Heading = styled.h3`
  font-size: ${theme.h3};
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
  line-height: ${theme.lineHeight2};
`;

const Text = styled.p`
  font-size: ${theme.h3};
  line-height: ${theme.lineHeight3};
  font-family: ${theme.display.fontFamily};
  font-weight: ${theme.display.fontWeight};
  margin-bottom: ${theme.space2};
  p:first-of-type: {
    padding-top: ${theme.space1};
  }
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h1};
  }
`;

const Meta = styled.span`
  font-size: ${theme.h4};
  font-family: ${theme.heading.fontFamily};
  font-weight: 400;
`;

const MetaWrap = styled.div`
  display: inline-block;
  line-height: 1;
  margin-left: -0.5em;
  padding: 0.5em;
  pading-top: 0.75em;
`;

const MaybeLink = ({ to, children }) => {
  if (!to) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return <Link to={to}>{children}</Link>;
};

export default ({ heading, text, meta, active, progress, uid }) => (
  <Screen>
    <MaybeLink to={uid}>
      <Text>{text}</Text>
      {(heading || meta) && (
        <div>
          <Heading>{heading}</Heading>
          <Meta>{meta}</Meta>
        </div>
      )}
    </MaybeLink>
  </Screen>
);



// WEBPACK FOOTER //
// ./src/components/WorkItem/index.js